import styled from 'styled-components';
import { Tabs, Input, Dropdown, Menu, Divider } from 'antd';

export const NoData = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};

  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const TabsPane = styled(Tabs)`
  &&& {
    .ant-tabs-nav-container-scrolling {
      padding: 0;
    }
    .ant-tabs-bar {
      margin: 0;
      border-bottom: 1px solid #e8e8e8 !important;
      /* border-bottom: 1px solid #eaeaea; */
      @media only screen and (min-width: 320px) and (max-width: 576px) {
        margin-bottom: 16px;
      }
    }
    .ant-tabs-nav-wrap {
      .ant-tabs-nav-scroll .ant-tabs-nav .ant-tabs-nav-animated {
        font-family: ${props =>
          props.theme.fontFamily.helveticaNeue} !important;
        font-size: 16px;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.6px;
      }

      .ant-tabs-tab-active {
        font-size: ${props => props.theme.fontSize.primary};
        border-style: solid;
        border-radius: 0px;
        border-width: 3px 0px 0px 0px !important;
        border-color: #006778 !important;
        border-bottom-color: #ffffff !important;
        background-color: #ffffff !important;
        border-right-width: 1px !important;
        border-right-color: #eaeaea !important;
        font-family: ${props =>
          props.theme.fontFamily.helveticaNeueBold} !important;
       // font-weight: bold !important;
        color: ${props => props.theme.colors.primaryColor} !important;
        margin-right: 0px !important;
        padding: 6px 18px 0px 18px !important;
        @media (max-width: 576px) {
          padding: 7px 18px 0px 18px !important;
        }
      }
      div > .ant-tabs-tab-active:first-child {
        border-left-width: 1px !important;
        border-left-style: solid !important;
        border-left-color: #eaeaea !important;
      }
      .ant-tabs-ink-bar {
        background-color: transparent !important;
      }

      .ant-tabs-tab {
        letter-spacing: ${props => props.theme.letterSpacing.normal};
        font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
        font-size: ${props => props.theme.fontSize.primary};
        border-style: solid;
        border-radius: 0px;
        border-width: 3px 0px 1px 0px;
        border-color: #e5eff1;
        border-bottom-color: #eaeaea;
        border-right-width: 1px;
        border-right-color: #eaeaea;
        background-color: #f4f3f3;
        color: #505050;
        margin-right: 0px !important;
        height: 56px !important;
        padding: 6px 18px 9px 18px !important;
        @media (max-width: 576px) {
          font-size: ${props => props.theme.fontSize.secondary};
          text-align: center;
          padding: 7px 10px 0px 10px !important;
        }
        @media (max-width: 990.98px) {
          font-size: ${props => props.theme.fontSize.secondary};
          text-align: center;
          padding: 7px 10px 0px 10px !important;
        }
      }
    }
  }
`;

export const DashboardDivider = styled(Divider)`
  width: 96%;
  margin-left: 20px;
  margin-bottom: 10px;
  margin-top: 0px;
`;

export const DashboardTab = styled(Tabs)`
  &&& {
    .ant-tabs-bar {
      margin-right: 30px;
      border-bottom: 1px solid #eaeaea;
      color: #022737;
    }
    @media (max-width: 576px) {
      .ant-tabs-bar {
        margin-right: 0px;
        border-bottom: 1px solid #eaeaea;
      }
    }
    .ant-tabs-nav-wrap {
      .ant-tabs-nav-scroll .ant-tabs-nav .ant-tabs-nav-animated {
        font-family: ${props =>
          props.theme.fontFamily.helveticaNeue} !important;
        font-size: 16px;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.6px;
        color: #022737;
      }

      .ant-tabs-tab-active {
        font-size: ${props => props.theme.fontSize.primary};
        border-style: solid;
        border-radius: 0px;
        border-width: 3px 0px 0px 0px !important;
        border-color: #006778 !important;
        border-bottom-color: #ffffff !important;
        background-color: #ffffff !important;
        border-right-width: 1px !important;
        border-right-color: #eaeaea !important;
        font-family: ${props =>
          props.theme.fontFamily.helveticaNeueBold} !important;
       // font-weight: bold !important;
        color: ${props => props.theme.colors.primaryColor} !important;
        margin-right: 0px !important;
        padding: 6px 18px 0px 18px !important;
        @media (max-width: 576px) {
          padding: 7px 18px 0px 18px !important;
        }
      }
      div > .ant-tabs-tab-active:first-child {
        border-left-width: 1px !important;
        border-left-style: solid !important;
        border-left-color: #eaeaea !important;
      }
      .ant-tabs-ink-bar {
        background-color: transparent !important;
      }
      .ant-tabs-tab {
        font-size: ${props => props.theme.fontSize.primary};
        border-style: solid;
        border-radius: 0px;
        border-width: 3px 0px 1px 0px;
        border-color: #e5eff1;
        border-bottom-color: #eaeaea;
        border-right-width: 1px;
        border-right-color: #eaeaea;
        background-color: #f4f3f3;
        font-family: ${props =>
          props.theme.fontFamily.helveticaNeue} !important;
       // font-weight: bold;
        color: ${props => props.theme.fontColors.textColor};
        margin-right: 0px !important;
        height: 56px !important;
        padding: 6px 18px 9px 18px !important;
        @media (max-width: 990.98px) {
          font-size: ${props => props.theme.fontSize.secondary};
          text-align: center;
          padding: 7px 10px 0px 10px !important;
        }
      }
    }
  }
`;
export const TabContainer = styled.div`
  border-bottom: ${props => (props.noBorder ? 'none' : 'solid 1px #f2f2f2')};
  border-bottom: ${props => (props.noBorder ? 'none' : 'solid 1px #f2f2f2')};
  border-left: ${props => (props.noBorder ? 'none' : 'solid 1px #f2f2f2')};
  border-right: ${props => (props.noBorder ? 'none' : 'solid 1px #f2f2f2')};
  overflow-y: ${props => (props.yscroll ? 'auto' : 'hidden')};
  overflow-x: ${props => (props.xscroll ? 'auto' : 'hidden')};
  height: ${props => props.height};
  margin-right: 10px;
`;

export const TabContent = styled.div`
  @media (max-width: 576px) {
    //padding: 10px 10px;
  }
`;

export const SearchContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

export const SearchInput = styled(Input.Search)`
  .ant-input {
    border-radius: 0px !important;
  }
  width: 210px;
  margin: 20px 24px 20px 0px;
`;

export const FilterWrapper = styled.div`
  width: 80px;
  // height:24px;
  padding: 8px 8px 8px 11px;
  font-size: 14 px;
  margin: 20px 0px 20px 0px;
  border: 1px solid ${props => props.theme.colors.border};
`;

export const QueryResult = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  margin: 0px 0px;
  text-align: center;
  font-weight: ${props => props.theme.fontWeight.bold};
  display: block;
`;

export const DropdownList = styled(Dropdown)`
  z-index: 1 !important;
  & > .ant-dropdown {
    z-index: 1 !important;
    left: 15.5px;
    top: 520px;
    width: 85%;
  }
`;

export const StyledMenu = styled(Menu)`
  margin-left: 20px;
  padding: 10px 10px;
  border: 1px solid #eee;
  & .ant-menu-item {
    height: 65px;
    padding: 10px;
    border: 1px solid #bfbfbf;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  }
  .ant-menu-vertical {
    height: auto;
  }
  .ant-menu-item {
    height: auto;
  }
`;

export const NoDataDiv = styled.div`
  height: ${props => props.height};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;